import { useEffect, useState } from "react";
import { stripe as api } from "@/lib/api/stripe";
import type { PricingOffer } from "@/lib/pricing";
import { useAuth } from "@/hooks/useAuth";

/** What this visitor pays right now; refetched when the session changes. */
export function usePricingOffer(): PricingOffer | null {
  const { user } = useAuth();
  const userId = user?.id ?? null;
  const [offer, setOffer] = useState<PricingOffer | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .getPricing()
      .then((next) => {
        if (!cancelled) setOffer(next);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return offer;
}
